import { render, staticRenderFns } from "./IconSvgUp.vue?vue&type=template&id=7dcb1988&scoped=true&"
import script from "./IconSvgUp.vue?vue&type=script&lang=js&"
export * from "./IconSvgUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcb1988",
  null
  
)

export default component.exports